import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import QRCodeList from './pages/QRCodeList';
import Reports from './pages/Reports';
import UserManagement from './pages/UserManagement';
import { authService } from './services/auth';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const user = await authService.getCurrentUser();
      setIsAuthenticated(!!user);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    authService.signOut();
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ?
            <Navigate to="/dashboard" /> :
            <Login onLogin={handleLogin} />
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ?
            <Dashboard onLogout={handleLogout} /> :
            <Navigate to="/login" />
          }
        />
        <Route
          path="/qrcodes"
          element={
            isAuthenticated ?
            <QRCodeList onLogout={handleLogout} /> :
            <Navigate to="/login" />
          }
        />
        <Route
          path="/reports"
          element={
            isAuthenticated ?
            <Reports onLogout={handleLogout} /> :
            <Navigate to="/login" />
          }
        />
        <Route
          path="/users"
          element={
            isAuthenticated ?
            <UserManagement onLogout={handleLogout} /> :
            <Navigate to="/login" />
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;